import { DriveInput } from "../types";
import {
  menuAnchor,
  twoStepFeedTrigger,
  guidedTourLink,
  waitForButton,
  standardDriverData,
} from "../helpers";
import { waitForElement } from "../helpers/functions";

const campaignDriverTitle = "Campaigns Configuration";
const campaignDriverData: DriveInput[] = [
  {
    description:
      "Click on the campaigns section. Here you will see preconfigured campaigns for search and for recommendations.",
    stepTitle: "Campaigns Section",
    customNotification: "Active Visual Search campaign is required to continue",
  },
  {
    description:
      "This is the Visual search campaign. Please click to see the default settings and to try it out.",
    stepTitle: "Visual Search",
    anchorElement: ".card-VPS-active",
    onNextClick: async () =>
      await twoStepFeedTrigger("card-VPS-active", "testSettingsButton", true),
  },
  {
    description:
      "Click the button Test Settings to open the user interface of the visual search. You can upload an image or start your camera and search in you analysed products.",
    stepTitle: "Try it out",
    anchorElement: "#vviinn-vps-button-container",
    side: "top",
    align: "center",
    onNextClick: async () => await waitForButton("testSettingsButton"),
    onPreviousClick: async () =>
      await twoStepFeedTrigger("#allCampaignsButton", "card-VPS-active"),
  },
  {
    description: `If you don't get any results, your products might not be analysed yet. Please try again later or contact ${guidedTourLink(
      "mailto:support@vviinn.com",
      "support@vviinn.com",
    )} for personal onboarding.`,
    stepTitle: "Support Contact",
    side: "top",
    align: "center",
    step: (
      <>
        If you don't get any results, your products might not be analysed yet.
        Please try again later or contact{" "}
        {guidedTourLink(
          "mailto:support@vviinn.com",
          "support@vviinn.com",
          false,
        )}
        .
      </>
    ),
    onPreviousClick: async () => {
      const shadowRef = document
        .getElementById("vviinn-vps-button-container")
        ?.getElementsByClassName("hydrated")[0].shadowRoot
        ?.lastChild as HTMLElement;
      if (shadowRef) {
        const shadowButtonModal = shadowRef.shadowRoot
          ?.firstChild as HTMLElement;
        if (shadowButtonModal) {
          const shadowOverlay = shadowButtonModal.shadowRoot
            ?.firstChild as HTMLElement;
          if (shadowOverlay) {
            const vviinnModal = shadowOverlay.getElementsByClassName(
              "first-screen hydrated",
            )[0] as HTMLElement;
            if (vviinnModal) {
              const vviinnHead = vviinnModal.shadowRoot
                ?.firstChild as HTMLElement;
              if (vviinnHead) {
                const vviinnButton = vviinnHead.getElementsByClassName(
                  "close-button",
                )[0] as HTMLButtonElement;
                if (vviinnButton) {
                  vviinnButton.click();
                  return true;
                }
              }
            }
          }
        }
      }
      return false;
    },
  },
];

export const campaignsGuide = () => {
  const zeroItemId = menuAnchor("Campaigns");
  const previousItemId = menuAnchor("Site");
  const campaignDriverDetails = standardDriverData(
    campaignDriverTitle,
    campaignDriverData,
    zeroItemId,
  );

  campaignDriverDetails.driverData.stepsData[0].onNextClick = async () => {
    const gotList = await twoStepFeedTrigger(zeroItemId, "campaignsList");
    if (!gotList) return false;
    let targetCampaign = document.getElementsByClassName("card-VPS-active");
    if (!targetCampaign.length) {
      const showAll = document.getElementById("resetFilters");
      if (showAll) showAll.click();
    }
    return waitForElement(".card-VPS-active");
  };
  campaignDriverDetails.driverData.stepsData[0].onPreviousClick = async () => {
    const firstStep = await twoStepFeedTrigger(
      previousItemId,
      "uploadFeedButton",
    );
    if (firstStep) {
      return await twoStepFeedTrigger(
        "uploadFeedButton",
        "productFeedImportUrl",
      );
    }
    return false;
  };

  return campaignDriverDetails;
};
